import { useState } from 'react';

const STORAGE_KEY = 'alea_pagination_per_page';
const DEFAULT_PER_PAGE = 10;

export const usePerPageStorage = () => {
  const [perPage, setPerPage] = useState<number>(() => {
    // Initialize with localStorage value if available
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsedValue = parseInt(stored, 10);
        if (!isNaN(parsedValue) && parsedValue > 0) {
          return parsedValue;
        }
      }
    } catch (error) {
      console.warn('Failed to load per page value from localStorage:', error);
    }
    return DEFAULT_PER_PAGE;
  });

  // Save to localStorage when value changes
  const updatePerPage = (newPerPage: number) => {
    try {
      setPerPage(newPerPage);
      localStorage.setItem(STORAGE_KEY, newPerPage.toString());
    } catch (error) {
      console.warn('Failed to save per page value to localStorage:', error);
    }
  };

  return {
    perPage,
    updatePerPage,
    defaultPerPage: DEFAULT_PER_PAGE
  };
};